import React from "react";
import longterm from "../assets/rankridgecollegewebsiteimages 01/longtermiit.webp";
import neet from "../assets/rankridgecollegewebsiteimages 01/neet.webp";
import CommonImageSlider from "./comandata";
import CallandRegisterComponent from "./Callbutton";
import {homeImages, jeeRanks, longtermCourse } from "./data";
import CommonImageSliderRanks from "./CommonsliderRanks";
import RankridgeIITJEE from "./subcomponents/RankridgeIITJEE";

const LongtermWithIITJee = () => {
  return (
    <div>
       {/* <h1 className="text-xl sm:text-xl text-[#20b2aa] md:text-3xl lg:text-4xl font-bold mb-4 text-center">
         Best IIT-JEE Mains & Advanced Long Term Coaching in Hyderabad
        </h1>
      <CommonImageSliderRanks images={jeeRanks}/> 

<CallandRegisterComponent />

      <CommonImageSlider images={longtermCourse}/>  */}
<RankridgeIITJEE />

    
    </div>
  );
};

export default LongtermWithIITJee;
